export const windowNavigator = {
  userAgentMatch(reg: RegExp) {
    return 'navigator' in window && window.navigator.userAgent.match(reg);
  }
};
